"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class ExtraBoldItalicStyle {
    constructor() {
        this.name = types_1.FontStyleName.EXTRABOLDITALIC;
        this.style = graphql_schema_types_1.FontStyle.Italic;
        this.weight = 800;
    }
}
exports.default = ExtraBoldItalicStyle;
//# sourceMappingURL=ExtraBoldItalicStyle.js.map